import React from "react";
import RadialSeparators from "./../ScoreMeter/RadialSeparators";
import "./ScoreMeter.scss";

function ScoreMeter(props) {
	const value = props.percentage;
	const fillerRelativePercentage = (100 / value) * 100;

	return (
		<div
			className="barContainer"
			style={{ height: props.onDetectScroll ? "28px" : "30px" }}>
			<div className="filler" style={{ width: `${value}%` }}>
				<div
					className="fillerBackground"
					style={{ width: `${fillerRelativePercentage}%` }}
				/>
			</div>
			<RadialSeparators />
		</div>
	);
}

export default ScoreMeter;
